import styles from './styles/GamePickEm.module.scss';
import { COMPLETED } from 'constants/GameStatuses';
import { useGameContainer } from '../index';
import useScreenSize from 'hooks/useScreenSize';
import ContentSection, { ContentSectionHeader } from '@/components/ContentSection';
import { SectionHeaderSize } from '@/components/SectionHeader';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';
import PickEmModule from '@/components/modules/PickEmModule';
import PlayPickEmModal from './PlayPickEmModal';
import dayjs from 'dayjs';

export default function GamePickEm() {
  const [{ game, pickEmGameTeamId, showPlayPickEmModal }, { pickTeam, closePlayPickEmModal }] = useGameContainer();
  const { isSmallScreen } = useScreenSize();

  if (game.gameTeams.some(({ team }) => team.name === 'TBA')) return null;

  const totalVotes = game.contest?.contestParticipants?.reduce((sum, team) => sum + (team.votes ?? 0), 0) ?? 0;
  const disableVote = dayjs() > dayjs(game.date) || game.statusId === COMPLETED;

  const homeGameTeam = game.gameTeams.find(gameTeam => gameTeam.isHome);
  const awayGameTeam = game.gameTeams.find(gameTeam => !gameTeam.isHome);

  if (!homeGameTeam || !awayGameTeam) {
    return null;
  }

  return (
    <ContentSection>
      <ContentSectionHeader size={SectionHeaderSize.LARGE} right={<ApplicationShareButton />}>
        {isSmallScreen ? "Pick 'Em" : "Pick 'Em Challenge"}
      </ContentSectionHeader>
      <div className={styles.PeopleVoted}>
        {disableVote ? (
          <>
            {totalVotes} {totalVotes === 1 ? 'person has' : 'people have'} voted on this game
          </>
        ) : (
          'Who will win this matchup?'
        )}
      </div>
      <PickEmModule
        game={game}
        totalCheers={totalVotes}
        disableVote={disableVote}
        pickEmGameTeamId={pickEmGameTeamId}
        pickTeam={pickTeam}
      />
      {showPlayPickEmModal && game.contest.bracket && (
        <PlayPickEmModal bracketWebPath={`${game.contest.bracket.webPath}/pickem`} onClose={closePlayPickEmModal} />
      )}
    </ContentSection>
  );
}
